export default "__VITE_ASSET__5b560d81__"